import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { Box, Typography } from '@mui/material';
import { BackrsForm } from '../BackrsForm/BackrsForm';
import { ResendCode } from '../BackrsForm/ResendCode';
var LOGIN_STRINGS = appStrings.modules.login;
var defaultOtpValues = {
    code: '',
};
var BackToLogin = function (_a) {
    var handleClick = _a.handleClick;
    return (_jsxs(Box, { id: "otp-back-to-login", "data-ph-capture-attribute-name": "otp-back-to-login", onClick: handleClick, sx: backToLoginSx, children: [_jsx(AppIcon, { iconName: "ArrowLeft", diameter: "20px", color: "Gray/600" }), _jsx(Typography, { variant: "text-sm-semibold", color: function (theme) { return theme.backrs.colors['Gray/600']; }, children: LOGIN_STRINGS.otp.backToLogin })] }));
};
export var OneTimePassword = function (_a) {
    var handleOtpCode = _a.handleOtpCode, errorMessage = _a.errorMessage, environmentUrl = _a.environmentUrl, _b = _a.phone, phone = _b === void 0 ? '555-555-5555' : _b, handleBackToLoginNav = _a.handleBackToLoginNav;
    var fields = [
        {
            id: 'code',
            name: 'code',
            placeholder: '######',
            type: 'tel',
            autoComplete: 'code',
            sx: otpInputStyle,
            inputProps: otpInputProps,
        },
    ];
    var handleSubmission = function (data) {
        handleOtpCode(data.code);
    };
    return (_jsx(Box, { sx: containerStyle, children: _jsxs(Box, { sx: loginFormStyle, children: [_jsx(Box, { sx: emailIconContainerSx, children: _jsx(AppIcon, { iconName: "Mail01", diameter: "28px", color: "Colors/Foreground/fg-secondary" }) }), _jsxs(Box, { sx: textContainerSx, children: [_jsx(Typography, { variant: "display-xs-semibold", children: LOGIN_STRINGS.otp.title }), _jsxs(Typography, { variant: "text-md-regular", color: function (theme) { return theme.backrs.colors['Colors/Text/text-tertiary']; }, children: [LOGIN_STRINGS.otp.sentCodeTo, _jsx("br", {}), _jsx(Typography, { component: "span", variant: "text-md-semibold", children: phone })] })] }), _jsx(BackrsForm, { fields: fields, defaultValues: defaultOtpValues, onSubmit: handleSubmission, buttonLabel: LOGIN_STRINGS.otp.verifyPhoneNumber, buttonId: "otp-verify-button", variant: "otp", children: _jsxs(Box, { sx: otpContentWrapperStyle, children: [_jsx(ResendCode, { environmentUrl: environmentUrl }), _jsx(BackToLogin, { handleClick: handleBackToLoginNav })] }) }), errorMessage && (_jsx(Typography, { mt: 2, variant: "text-sm-regular", color: function (theme) { return theme.backrs.colors['Error/600']; }, children: errorMessage }))] }) }));
};
var backToLoginSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        gap: backrs.spacing['spacing-md'],
        cursor: 'pointer',
    });
};
var textContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-md'],
        textAlign: 'center',
        maxWidth: '300px',
        marginBottom: backrs.spacing['spacing-4xl'],
    });
};
var emailIconContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        padding: '14px',
        borderRadius: backrs.radius['radius-xl'],
        border: "1px solid ".concat(backrs.colors['Gray/200']),
        background: backrs.colors['Colors/Base/White'],
        boxShadow: backrs.shadows['shadow-xs-skeuomorphic'],
        marginBottom: backrs.spacing['spacing-3xl'],
    });
};
var containerStyle = {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
};
var loginFormStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        backgroundColor: {
            xs: backrs.colors['Colors/Base/Transparent'],
            sm: backrs.colors['Colors/Base/White'],
        },
        paddingX: backrs.spacing['spacing-8xl'],
        paddingY: backrs.spacing['spacing-5xl'],
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: '100%',
        width: '100%',
        boxSizing: 'border-box',
        '@media (min-width: 600px)': {
            maxWidth: '500px',
        },
        boxShadow: {
            xs: 'none',
            sm: backrs.shadows['shadow-2xl'],
        },
        border: {
            xs: 'none',
            sm: "3px solid ".concat(backrs.colors['Colors/Base/Black']),
        },
    });
};
var otpContentWrapperStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};
var otpInputStyle = {
    mb: 4,
};
var otpInputProps = {
    style: { textAlign: 'center', letterSpacing: '0.75rem', fontSize: '1.5rem' },
    maxLength: 6,
};
